import { Dialog, Transition } from "@headlessui/react"
import { Fragment } from "react"

interface SaveModalProps {
    isOpen: boolean
    closeModal: () => void
}

export function SaveModal(props: SaveModalProps) {
    return (
        <Transition appear show={props.isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={props.closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className={`w-full max-w-md transform overflow-hidden rounded-2xl bg-neutral-900 p-6 text-left align-middle shadow-xl transition-all`}>
                                <Dialog.Title
                                    as="h3"
                                    className={`text-lg font-medium leading-6 text-white`}
                                >
                                    Bookmark this page 
                                </Dialog.Title>
                                <div className="mt-2">
                                    <p className="text-sm text-gray-400 pb-1">
                                        Saving results to the library is not yet implemented.
                                    </p>
                                    <p className="text-sm text-gray-400 py-1">
                                        Please bookmark this page by pressing the star in the address bar of your browser.
                                    </p>
                                    <p className="text-sm text-gray-400 pt-1">
                                        Alternatively, you can copy the URL from the address bar and save it somewhere.
                                    </p>
                                </div>

                                <div className="mt-4">
                                    <button
                                        type="button"
                                        className={`inline-flex justify-center rounded-md border border-transparent bg-neutral-800 text-indigo-500 hover:text-indigo-600 px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2`}
                                        onClick={props.closeModal}
                                    >
                                        Close
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default SaveModal